import { menuRoutes } from '@menu/routes';
import { optimizerRoutes } from '@optimizer/routes';
import { optimizerProRoutes } from '@optimizerPro/routes';
import { manualConfigRoutes } from '@manualConfig/routes';
import { mastersRoutes } from '@masters/routes';
import { reportingRoutes } from '@reporting/routes';
import PointOfSale from './PointOfSale.vue';
import { restaurantManagementRoutes } from './views/restaurantManagement/routes';
import { powerBiReportingRoutes } from '@powerBiReporting/routes';

export const pointOfSaleRoutes = [
  {
    path: '',
    component: PointOfSale,
    children: [
      ...menuRoutes,
      ...optimizerRoutes,
      ...optimizerProRoutes,
      ...restaurantManagementRoutes,
      ...manualConfigRoutes,
      ...reportingRoutes,
      ...mastersRoutes,
      ...powerBiReportingRoutes
    ]
  }
];
